import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './_services/auth.service';
import { RegisterComponent } from './register/register.component';
import { AuthGuard } from './_guards/auth.guard';
import { ErrorInterceptorProvider } from './_services/error.interceptor';
import { LoaderInterceptorService } from './_services/loader-interceptor.service';
import { LoaderComponent } from './loader/loader.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HomeModule } from './home/home.module';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';
import { ChartsModule } from 'ng2-charts';
import { NavService } from './_services/nav.service';
import { NgbdSortableHeader } from './home/informes/irm/sortable.directive';
import { NgxTranslateModule } from './translate.module';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import {
  MSAL_INSTANCE,
  MsalModule,
  MsalService,
  MsalRedirectComponent,
  MsalInterceptor,
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { PendingUserComponent } from './pending_user/pending-user.component';
import { QueriesComponent } from './queries/queries.component';
import { CreateCompanyComponent } from './create-company/create-company.component';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.CLIENT_ID,
      authority: environment.TENANT,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
    },
  });
}
@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    LoaderComponent,
    ConfirmEmailComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PageNotFoundComponent,
    TwoFactorAuthenticationComponent,
    PendingUserComponent,
    QueriesComponent,
    CreateCompanyComponent,
  ],
  imports: [
    BrowserModule,
    HomeModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    NgxTranslateModule,
    ModalModule.forRoot(),
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.CLIENT_ID,
          authority: environment.TENANT,
          redirectUri: environment.REDIRECT_URI, //defaults to application start page
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        },
      }),
      {
        interactionType: InteractionType.Redirect, // Msal Guard Configuration
        authRequest: {
          scopes: [environment.SCOPES], // aquí se incluyen los scopes solicitados al usuario durante la autenticación
          prompt: 'select_account',
        },
      },
      null
    ),
    NgSelectModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthGuard,
    BsModalRef,
    DatePipe,
    ErrorInterceptorProvider,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    NavService,
    DecimalPipe,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  exports: [ToastrModule],
})
export class AppModule {}
